import { render, staticRenderFns } from "./overallPerStaffTicketStats.vue?vue&type=template&id=28bfd7db&scoped=true"
import script from "./overallPerStaffTicketStats.vue?vue&type=script&lang=js"
export * from "./overallPerStaffTicketStats.vue?vue&type=script&lang=js"
import style0 from "./overallPerStaffTicketStats.vue?vue&type=style&index=0&id=28bfd7db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bfd7db",
  null
  
)

export default component.exports